import React from 'react'
import ImagesUroliftGallery from "./ImagesUroliftGallery"
import {Link} from "@material-ui/core"

const Urolift_EN = () => {
    return (
        <section id="about1">
            <div className="row">
                <h2>What is the UroLift system?</h2>
                <p className="white">
                    Treatment with the UroLift System is usually a one-time solution that provides rapid relief from
                    symptoms of BPH and recovery. It can interrupt the cycle of medication use without the risks of more
                    invasive surgery. The aim of treatment with the UroLift System is to relieve BPH symptoms so that
                    patient can return to normal activities in the daily life.
                    <br/>
                    Treatment with the UroLift system has been shown to lead to a significant improvement in quality of
                    life
                    compared to drug therapy. The UroLift system is the only BPH procedure that has been proven to not
                    cause
                    new and permanent erectile dysfunction or ejaculation disorders* and is also a safe and an effective
                    treatment for BPH-related lower urinary tract symptoms.
                    <br/>
                    <h2>How does it work?</h2>
                    BPH treatment with the UroLift System uses a groundbreaking approach in which the enlarged prostate
                    tissue is lifted and held to the side so that it no longer blocks the urethra. Treatment is
                    performed by
                    a urologist and does not require heating, cutting, or removal of prostate tissue. UroLift System
                    treatment is typically performed using only local anesthesia in a physician’s office or ambulatory
                    surgery center. Patients experience rapid symptom relief, significant improvement in quality of life
                    and
                    preservation of sexual function.The goal of the UroLift System treatment is to relieve symptoms so
                    you
                    can get back to your life and resume your daily activities.
                    <br/>
                   <ImagesUroliftGallery/>
                    <i>No new, persistent erectile dysfunction or ejaculation disorders</i>
                    <br/>
                    Source: <Link href="https://de.urolift.com/what-is-urolift" target="_blank">https://de.urolift.com/what-is-urolift</Link>
                </p>
            </div>
        </section>
    )
}

export default Urolift_EN


// WEBPACK FOOTER //
// ./src/Components/Urolift/Urolift_EN.js